import { getMediaUrl as getMediaUrlCommon } from "@common/components/Media/lib";

export const getMediaUrl = getMediaUrlCommon;
